export default function willCatchAndToast(toast) {
	return function (error) {
		if (error){
			console.error(error);
			toast?.(error?.message || String(error) || `Une erreur est survenue.`);
		}
	};
}
